import React, { useState } from "react";
import useRequest from "hooks/useRequest";
import movieAPI from "apis/movieAPI";
import { Content } from "antd/lib/layout/layout";
import { Breadcrumb } from "antd";

const Showtimes = ({ movieId }) => {
  // useRequest call API lấy lịch chiếu
  const [change, setChange] = useState(false)


  const { data: movie, isLoading, error } = useRequest(() => movieAPI.getMovieDetails(movieId), { refreshDeps: [change] })
  return (
    <>
      <Content style={{ margin: '0 16px' }}>
        <Breadcrumb style={{ margin: '16px 0' }}>

        </Breadcrumb>


        <h1>Tạo lịch chiếu - {movie.tenPhim}</h1>
      </Content>
    </>
  )
};

export default Showtimes;
